import { useEffect } from 'react';
import { useShell } from '../provider';
import { createNotificationStreamConnection } from './notification-stream-connection';

export function useNotificationStream(
  enabled: boolean,
  userId: string | undefined,
  onUpdate: () => void
) {
  const { notificationApi } = useShell();

  useEffect(() => {
    if (!enabled || !notificationApi || !userId || !window.EventSource) return;

    const connection = createNotificationStreamConnection(
      notificationApi,
      userId,
      onUpdate
    );
    const updateActivity = () => {
      if (document.visibilityState === 'visible' && navigator.onLine) {
        connection.resume();
      } else {
        connection.suspend();
      }
    };

    document.addEventListener('visibilitychange', updateActivity);
    window.addEventListener('online', updateActivity);
    window.addEventListener('offline', updateActivity);
    updateActivity();

    return () => {
      document.removeEventListener('visibilitychange', updateActivity);
      window.removeEventListener('online', updateActivity);
      window.removeEventListener('offline', updateActivity);
      connection.dispose();
    };
  }, [enabled, notificationApi, userId, onUpdate]);
}
